// Combined reporting (PRD 41) ships dark: the page, its route and its reports
// tile appear only once this is true. It flips in its own PR, after the api's
// combined-reporting endpoints are on prod (greenbackapp/api#845 and the PRs
// stacked on it: the schedules, saved runs and exports).
//
// A merge-after note in a PR description doesn't stop a merge; a false
// constant does.
export const COMBINED_REPORTING_LIVE = false;
